import { useKeycloak } from '@react-keycloak/web';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import CPageModule from '../../components/CPageModule';
import { EFactsheetClasses } from '../../enums/EFactsheetClasses';
import { PageRoutes } from '../../enums/enums';
import { getFactsheetId, updateStateAttribute } from '../../helpers/helper';
import { type IRequestState } from '../../models/IRequestState';
import PublicFactsheetServices from '../../services/publicFactsheetServices';
import SelfServiceSignUp from './SelfServiceSignUp';

/**
 * This is the Page that is called when the URL is `/fs` (i.e. no Factsheet ID is declared on the URL -- thus we need to
 * speculate the Factsheet ID it in the following order:
 * 1) If the user is logged in, check the backend for the last FS ID associated with the user.
 *   1) If the API call fails, redirect to request page.
 * 2) Check the Local Storage if there is the browser had "agreed" to one of a factsheet ID's terms.
 *   1) If there is none, redirect to request page.
 * If not, we redirect the user to a factsheet sign-up page `/fs/request`.
 * @constructor
 */
interface State {
  reqState: IRequestState;
}

export default function PublicFactsheetIndex() {
  const { keycloak } = useKeycloak();
  const navigate = useNavigate();
  const factsheetId = getFactsheetId(EFactsheetClasses.US_AMERICAN_STOCKS);
  const [state, setState] = useState<State>({ reqState: { isLoading: false, isError: false } });

  useEffect(() => {
    (async () => {
      let targetUri: string | undefined;
      if (keycloak.authenticated) {
        updateStateAttribute({ reqState: { isLoading: true, isError: false } }, setState);
        const res = await PublicFactsheetServices.getLastViewedFactsheet();
        if (!res.hasError()) {
          targetUri = `/${PageRoutes.PUBLIC_FACTSHEET_COLLECTION_OUTLET}/${res.getData().id}`;
        }
        updateStateAttribute(
          { reqState: { isLoading: false, isError: res.hasError(), strError: res.getErrorString() } },
          setState
        );
      } else if (factsheetId) {
        targetUri = `/${PageRoutes.PUBLIC_FACTSHEET_COLLECTION_OUTLET}/${factsheetId}`;
      }
      if (targetUri) navigate(targetUri);
    })();
  }, []);

  return (
    <>
      {state.reqState.isLoading && <CPageModule apiRequestState={state.reqState} />}
      {((!keycloak.authenticated && !factsheetId) || (keycloak.authenticated && state.reqState.isError)) && (
        <SelfServiceSignUp />
      )}
    </>
  );
}
